import { makeStyles } from "@material-ui/core/styles";


const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#000',
        padding: '48px 0',
        '& > span': {
            fontSize: '36px',
            fontWeight: '800',
            color: '#fff',
            textAlign: 'center',
            marginBottom: '24px',
            [theme.breakpoints.down('md')]: {
                fontSize: '30px',
            },
        },
        [theme.breakpoints.down('md')]: {
            padding: '30px 24px 40px 24px',
        },
    },
    logoList: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        flexWrap: 'nowrap',
        gap: '24px',
        '& > img': {
            objectFit: 'contain',
            margin: '0 24px',
            flexShrink: 0,
            [theme.breakpoints.down('md')]: {
                margin: '0',
                width: '90px',
                height: 'auto',
            }
        },
        [theme.breakpoints.down('sm')]: {
            flexWrap: 'wrap',
            gap: '16px',
            justifyContent: 'space-between',
            maxWidth: '100%',
        },
        [theme.breakpoints.up('md')]: {
            gap: '48px',
        }
    },
    logoItem: {
    },
    logoItemContainer: {
        [theme.breakpoints.down('md')]: {
            '&.hideOnMobile': {
                display: 'none',
            }
        },
        [theme.breakpoints.down('sm')]: {
            width: '25%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        }
    },
    hideOnMobile: {
        [theme.breakpoints.down('md')]: {
            display: 'none !important',
        }
    }
}));

export default useStyles;